import { cn } from '@/lib/utils'
import { cellClass, gridClass, gridStyle, type GridColumns } from '../layout/grid'
import type { WidgetConfig } from '../types'
import { WidgetRenderer } from '../widgets/WidgetRenderer'

export function WidgetGrid({ widgets, cols, className }: { widgets: WidgetConfig[]; cols?: GridColumns; className?: string }) {
  return (
    <div className={cn('@container', className)}>
      <div className={gridClass(cols)} style={gridStyle}>
        {widgets.map((w) => (
          <div key={w.id} className={cn('min-w-0', cellClass(w.w, w.h, cols))}>
            <WidgetRenderer config={w} />
          </div>
        ))}
      </div>
    </div>
  )
}
